import React, {EventHandler} from 'react';
import { addWeeks, format, parse } from 'date-fns';
import { useCallback } from 'react';
import { currentWeek } from '../utils';
import {IsoDatePicker} from "./IsoDatePicker";
import { IconButton} from "@mui/material";
import {ChevronLeft, ChevronRight, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight} from "@mui/icons-material";

type WeekSelectArgs = {
    onChange:EventHandler<any>,
    value:Date
}


export const WeekSelect = (props: WeekSelectArgs) => {
    const weekUpDown = (numWeeks) => (evt:React.MouseEvent) => {
//        const el = evt.target.closest('[data-weeks]');
        props.onChange({target:{value:addWeeks(props.value,numWeeks)}});
    };
    const doChange = useCallback((evt)=> {
        evt.target.value = parse(evt.target.value,'yyyy-MM-dd',currentWeek());
        props.onChange(evt);
    },[]);
    return <div><IconButton   onClick={weekUpDown(-4)} ><KeyboardDoubleArrowLeft/></IconButton><IconButton
        onClick={weekUpDown(-1)}><ChevronLeft/></IconButton>
        <IsoDatePicker value={format(props.value, 'yyyy-MM-dd')} name="picker" onChange={doChange} label="date" mondayOnly={true}/>
        <IconButton onClick={weekUpDown(1)} ><ChevronRight/></IconButton><IconButton onClick={weekUpDown} data-weeks="4" ><KeyboardDoubleArrowRight/></IconButton></div>;
};
/*
WeekSelect.propTypes = {
    onChange:PropTypes.func.required,
    value:PropTypes.object.required
}


export default WeekSelect;*/